
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["circleClose_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512zm0-572.33L300.63 240.212a42.539 42.539 0 00-60.16.214 42.41 42.41 0 00-.214 60.16L451.669 512 240.213 723.37a42.539 42.539 0 00.214 60.16 42.41 42.41 0 0060.16.214L512 572.331l211.37 211.413a42.539 42.539 0 0060.16-.213 42.41 42.41 0 00.214-60.16L572.331 512l211.413-211.37a42.539 42.539 0 00-.213-60.16 42.41 42.41 0 00-60.16-.214L512 451.669z","fill":"#fff"}})])
          )
        }
      }
    